import { Navigate, type RouteObject } from 'react-router';
import { FLAGGED_AREA_ROUTES } from './features/flagged-areas/flagged-areas.routes';
import { RedirectToZone } from './pages/RedirectToZone';
import { ZonesPage } from './pages/ZonesPage';
import { ZONE_VIEWS, zoneViewPath } from './zones.paths';

export const ZONE_ROUTES: RouteObject[] = [
  // Zones used to be a reference-data tab; its old URLs redirect.
  { path: 'reference-data/zones', element: <Navigate to={zoneViewPath(ZONE_VIEWS[0])} replace /> },
  { path: 'reference-data/zones/:id', element: <RedirectToZone /> },
  { path: 'zones', element: <Navigate to={zoneViewPath(ZONE_VIEWS[0])} replace /> },
  ...ZONE_VIEWS.map((view) => ({ path: `zones/${view}`, element: <ZonesPage view={view} /> })),
  // Same component as the map view, so React keeps the map mounted while a zone's panel opens and closes.
  { path: 'zones/new', element: <ZonesPage view="map" panel="new" /> },
  { path: 'zones/:id', element: <ZonesPage view="map" panel="zone" /> },
  // The table's zone sheet: the record under its tab, so closing lands back on the same page of the table.
  { path: 'zones/list/new', element: <ZonesPage view="list" panel="new" /> },
  { path: 'zones/list/:id', element: <ZonesPage view="list" panel="zone" /> },
  // React Router ranks the static `zones/flagged` above `zones/:id`, so these never read "flagged" as a zone id.
  ...FLAGGED_AREA_ROUTES,
];
